import React, { useState } from 'react'
// import { FormattedMessage } from 'react-intl'
import { useHistory } from 'react-router-dom'
import MarkdownMessage from '@gluedigital/markdown-message'
import SearchInput from 'src/components/SearchInput/SearchInput'
import Table from 'src/components/Table/Table'
import { useFilteredUsers } from 'src/hooks/api'
import { User } from 'src/types'
import AcudaCell from './AcudaCell'

import './Users.sass'

const Users = () => {
  const history = useHistory()
  const [filter, setFilter] = useState(history?.location?.state?.user || '')
  const filteredUsers = useFilteredUsers(filter)

  const handleFilter = newFilter => {
    history.replace('/', { ...history?.location?.state, user: newFilter })
    setFilter(history?.location?.state?.user)
  }

  return (
    <div id="users-home" className="page-content-section">
      <header className="only-desktop">
        <h1>
          <MarkdownMessage id="users-home.title" values={{ n: filteredUsers.length }} />
        </h1>
      </header>
      <SearchInput value={filter} onChange={handleFilter} />
      <Table
        handleSelect={(user: User) => history.push('/user/' + user.userId)}
        name={'users'}
        data={filteredUsers}
        columns={[
          { name: 'name' },
          { name: 'turnUp', component: AcudaCell }
        ]}
      />
    </div>
  )
}

export default Users
